ht.declare('.messageBox', function () {
  ht.flashMessage(this);
});
